
import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUtensils, FaHotel, FaSpa, FaHome, FaRing, FaGraduationCap, FaTruck, FaHospital,
  FaUserTie, FaDog, FaBed, FaUser, FaTooth, FaDumbbell, FaMoneyBill, FaCalendarAlt,
  FaCar, FaBox, FaShippingFast, FaListUl, FaCamera
} from 'react-icons/fa';
import './ServicePage.css';

const groupedCategories = [
  {
    group: 'Repairs & Services',
    items: [
      { name: 'Electrician', icon: <FaUserTie />, link: '/electrician' },
      { name: 'Carpenter', icon: <FaUserTie />, link: '/carpenter' },
      { name: 'Plumber', icon: <FaUserTie />, link: '/plumber' },
      { name: 'AC Service', icon: <FaUserTie />, link: '/acservice' },
      { name: 'CCTV & Home Services', icon: <FaUserTie />, link: '/cctvhomeservices' },
    ],
  },
  {
    group: 'Real Estate',
    items: [
      { name: 'Property agents', icon: <FaUser />, link: '/propertyagents' },
      { name: 'Brokers', icon: <FaUser />, link: '/brokers' },
      { name: 'PG/Hostels', icon: <FaBed />, link: '/pghostels' },
      { name: 'Estate Agents', icon: <FaUser />, link: '/estateagent' },
    ],
  },
  {
    group: 'Doctors & Health Services',
    items: [
      { name: 'Hospitals', icon: <FaHospital />, link: '/hospitals' },
      { name: 'Clinics', icon: <FaHospital />, link: '/clinics' },
      { name: 'Dentists', icon: <FaTooth />, link: '/dentists' },
      { name: 'Gynecologists', icon: <FaHospital />, link: '/gynecologists' },
      { name: 'Health Practitioners', icon: <FaHospital />, link: '/healthpractitioners' },
    ],
  },
  {
    group: 'Beauty & Wellness',
    items: [
      { name: 'Beauty Spa', icon: <FaSpa />, link: '/beautyspa' },
      { name: 'Salons', icon: <FaSpa />, link: '/salons' },
      { name: 'Massage', icon: <FaSpa />, link: '/massage' },
      { name: 'Yoga Studios', icon: <FaSpa />, link: '/yogastudios' },
    ],
  },
  {
    group: 'Home Decor & Renovation',
    items: [
      { name: 'Interior Decorators', icon: <FaHome />, link: '/interiordecorators' },
      { name: 'Contractors', icon: <FaUserTie />, link: '/contractors' },
      { name: 'Painters', icon: <FaHome />, link: '/painters' },
      { name: 'Home Furnishing', icon: <FaHome />, link: '/homefurnishing' },
    ],
  },
  {
    group: 'Event & Wedding Services',
    items: [
      { name: 'Event Organisers', icon: <FaCalendarAlt />, link: '/eventorganisers' },
      { name: 'Wedding Planners', icon: <FaRing />, link: '/weddingplanning' },
      { name: 'Photographers', icon: <FaCamera />, link: '/photographers' },
    ],
  },
  {
    group: 'Education & Training',
    items: [
      { name: 'Education', icon: <FaGraduationCap />, link: '/education' },
      { name: 'Institutes', icon: <FaGraduationCap />, link: '/institutes' },
      { name: 'Tutors', icon: <FaGraduationCap />, link: '/tutors' },
      { name: 'Coaching Classes', icon: <FaGraduationCap />, link: '/coachingclasses' },
      { name: 'Training Centers', icon: <FaGraduationCap />, link: '/trainingcenters' },
    ],
  },
  {
    group: 'Rent & Hire Services',
    items: [
      { name: 'Car/Bike Hire', icon: <FaTruck />, link: '/carbikehire' },
      { name: 'Driver on Call', icon: <FaTruck />, link: '/driveroncall' },
      { name: 'Equipment Rentals', icon: <FaTruck />, link: '/equipmentrentals' },
    ],
  },
  {
    group: 'Fitness & Lifestyle',
    items: [
      { name: 'Gyms', icon: <FaDumbbell />, link: '/gym' },
      { name: 'Trainers', icon: <FaDumbbell />, link: '/trainers' },
      { name: 'Sports Coaches', icon: <FaDumbbell />, link: '/sportscoaches' },
      { name: 'Wellness Programs', icon: <FaDumbbell />, link: '/wellnessprograms' },
    ],
  },
  {
    group: 'Loans & Finance',
    items: [
      { name: 'Loans', icon: <FaMoneyBill />, link: '/loans' },
      { name: 'Loan Consultants', icon: <FaMoneyBill />, link: '/loanconsultants' },
      { name: 'Financial Services', icon: <FaMoneyBill />, link: '/financialservices' },
      { name: 'Property Loans', icon: <FaMoneyBill />, link: '/propertyloans' },
    ],
  },
  {
    group: 'Food & Hospitality',
    items: [
      { name: 'Restaurants', icon: <FaUtensils />, link: '/restaurants' },
      { name: 'Hotels', icon: <FaHotel />, link: '/hotels' },
    ],
  },
  {
    group: 'Other',
    items: [
      { name: 'Pet Shops', icon: <FaDog />, link: '/petshops' },
      { name: 'Packers & Movers', icon: <FaBox />, link: '/packersmovers' },
      { name: 'Courier Service', icon: <FaShippingFast />, link: '/courierservice' },
      { name: 'Popular Categories', icon: <FaListUl />, link: '/popularcategories' },
      { name: 'Driving Schools', icon: <FaCar />, link: '/drivingschools' },
    ],
  },
];

const ServiceCategoriesGrid = () => {
  const navigate = useNavigate();
  return (
    <div className="service-categories-grouped-grid">
      {groupedCategories.map(group => (
        <div key={group.group} className="service-category-group mb-4">
          <h4 className="service-category-group-title">{group.group}</h4>
          <div className="service-categories-grid">
            {group.items.map(cat => (
              <div className="service-category-card" key={cat.name} onClick={() => navigate(cat.link)}>
                <span className="service-category-icon">{cat.icon}</span>
                <div className="service-category-label">{cat.name}</div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceCategoriesGrid;
